(function () {
class $90aeb529ce0938df$var$d {
    /**
   * @param {Function} observer
   * @return {{ unsubscribe: () => void }} - subscription object
   **/ subscribe(r) {
        return this._observers.add(r), this._messagesHistory.forEach((o)=>r(o)), {
            unsubscribe: ()=>this.unsubscribe(r)
        };
    }
    /**
   * @param {Function} observer
   * @return {void}
   **/ unsubscribe(r) {
        this._observers.delete(r);
    }
    /**
   * @param {T} data
   * @return {void}
   **/ notify(r) {
        this._messagesHistory.push(r), this._observers.forEach((o)=>o(r));
    }
    constructor(){
        this._observers = /* @__PURE__ */ new Set(), this._messagesHistory = [];
    }
}
function $90aeb529ce0938df$var$g(e, r) {
    return function(...o) {
        const t = Date.now();
        var _e_lastCall;
        if (!(t - ((_e_lastCall = e.lastCall) !== null && _e_lastCall !== void 0 ? _e_lastCall : 0) < r)) return e.lastCall = t, e(...o);
    };
}
function $90aeb529ce0938df$var$f() {
    var _document_querySelector;
    var _document_querySelector_getAttribute;
    return (_document_querySelector_getAttribute = (_document_querySelector = document.querySelector("head base")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getAttribute("href")) !== null && _document_querySelector_getAttribute !== void 0 ? _document_querySelector_getAttribute : "/";
}
async function $90aeb529ce0938df$var$w(e, r = "GET", o) {
    let { body: t, headers: n, ...a } = o !== null && o !== void 0 ? o : {};
    t !== null && typeof t == "object" && (t = JSON.stringify(t), n = {
        "Content-Type": "application/json",
        ...n
    });
    const s = await fetch(new URL(e, new URL($90aeb529ce0938df$var$f(), window.location.href)), {
        method: r,
        body: t,
        headers: n,
        ...a
    });
    if (!s.ok) throw new Error(`Request failed with status code ${s.status}`);
    return s;
}
const $90aeb529ce0938df$export$d16ba98760c74dd5 = {
    logException: ()=>Promise.resolve(!1)
};
async function $90aeb529ce0938df$export$fe2e61603b61130d() {
    async function e(r, o = "Warning", t = "") {
        const n = /* @__PURE__ */ new Date().toISOString(), a = typeof r == "string" ? r : JSON.stringify(r), s = {
            logLevel: o !== null && o !== void 0 ? o : "Warning",
            text: a,
            stack: t,
            timestamp: n,
            url: window.location.pathname,
            browserLanguage: // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.navigator.language || window.navigator.userLanguage || "",
            userAgent: window.navigator.userAgent || "",
            browserVendor: window.navigator.vendor || ""
        };
        try {
            return await $90aeb529ce0938df$var$w("/Log/ClientError", "POST", {
                body: s
            }), !0;
        } catch (l) {
            return console.error("Error logging exception", l), !1;
        }
    }
    return {
        logException: e
    };
}
const $90aeb529ce0938df$var$u = new $90aeb529ce0938df$var$d(), $90aeb529ce0938df$export$f86b2a1a2ce291b3 = $90aeb529ce0938df$var$g(function(...r) {
    $90aeb529ce0938df$var$u.notify(r);
}, 100), $90aeb529ce0938df$var$h = 50;
$90aeb529ce0938df$export$fe2e61603b61130d().then((e)=>{
    const r = {
        count: 0
    };
    window.nepheleErrorLogger = e;
    const o = $90aeb529ce0938df$var$u.subscribe((t)=>{
        r.count++, e.logException(...t).catch(), r.count >= $90aeb529ce0938df$var$h && o.unsubscribe();
    });
});
const $90aeb529ce0938df$var$c = [
    "chrome-extension://",
    "moz-extension://"
];
function $90aeb529ce0938df$var$m(e) {
    var _e_error;
    const r = (e === null || e === void 0 ? void 0 : e.filename) || "";
    if ($90aeb529ce0938df$var$c.some((t)=>r.startsWith(t))) return !0;
    const o = (e === null || e === void 0 ? void 0 : (_e_error = e.error) === null || _e_error === void 0 ? void 0 : _e_error.stack) || "";
    return !!$90aeb529ce0938df$var$c.some((t)=>o.startsWith(t));
}
window.addEventListener("error", (e)=>{
    var _e_error;
    var _e_error_stack;
    $90aeb529ce0938df$var$m(e) || $90aeb529ce0938df$export$f86b2a1a2ce291b3(e.message, "Warning", (_e_error_stack = e === null || e === void 0 ? void 0 : (_e_error = e.error) === null || _e_error === void 0 ? void 0 : _e_error.stack) !== null && _e_error_stack !== void 0 ? _e_error_stack : "");
});
window.addEventListener("unhandledrejection", (e)=>{
    $90aeb529ce0938df$export$f86b2a1a2ce291b3(e.reason);
});
window.addEventListener("securitypolicyviolation", (e)=>{
    const r = {
        blockedURI: e.blockedURI,
        columnNumber: e.columnNumber,
        lineNumber: e.lineNumber,
        documentURI: e.documentURI,
        originalPolicy: e.originalPolicy,
        referrer: e.referrer,
        sourceFile: e.sourceFile,
        statusCode: e.statusCode,
        violatedDirective: e.violatedDirective
    };
    $90aeb529ce0938df$export$f86b2a1a2ce291b3(r, "Error");
});
window.addEventListener("DOMException", (e)=>{
    const r = e, o = {
        message: r.message,
        name: r.name
    };
    $90aeb529ce0938df$export$f86b2a1a2ce291b3(o);
});


logError = function logError1(err) {
    (0, $90aeb529ce0938df$export$f86b2a1a2ce291b3)(err);
};

})();
//# sourceMappingURL=logger.js.map
